export enum BPLoggerEventType {
  PageView = 'page_view',
  Login = 'login',
  Logout = 'logout',
  CreateUser = 'create_user',
  UpdateUser = 'update_user',
  StockSync = 'stock_sync',
  AddToCart = 'add_to_cart',
  SubmitShippingAddress = 'submit_shipping_address',
  SubmitShippingMethod = 'submit_shipping_method',
  AddPromoCode = 'add_promo_code',
  RemovePromoCode = 'remove_promo_code',
  SubmitPayment = 'submit_payment',
  CompletePayment = 'complete_payment',
  SubmitOrder = 'submit_order',
  SyncOrderWithOrderHub = 'sync_order_with_order_hub',
  SyncOrderWithD365 = 'sync_order_with_d365',
  BlockOrder = 'block_order',
  GenerateCommercialInvoice = 'generate_commercial_invoice',
  ReleaseOrder = 'release_order',
  FulFillOrder = 'fulfill_order',
  HandleShortage = 'handle_shortage',
  CreateOrderInvoice = 'create_order_invoice',
  CollectOrderPayment = 'collect_order_payment',
  CloseOrder = 'close_order',
}
